module.exports = __webpack_public_path__ + "img/四川天府新区万安中学.4cf991c4.jpg";